// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6643":"fa62ac94","15862":"1a3f8f17","37441":"609e5427","76572":"72f58892"}[chunkId] + ".chunk.css";
};